let socket = null;
let wsUrl = '';
let setIntervalWesocketPush = null;
let isShutdown = false;
let eventList = ["htmlBuildProgress","htmlBuildProgressInProductSeries","chessDemandDealProgress",
"chessQzoneChangeNotify","todoNotify","checkNotify","unCheckNotify","confirmNotify","refuseNotify",
"amountChangeNotify","systemNotify","businessNotify", "noticeNotify", "elseNotify","renewalNotify",
"dataChangeNotify","taxNotify","orderNotify","paymentNotify","reconciliationNotify"];

/**
 * 建立websocket连接
 * @param {string} url ws地址
 */
export const startSocket = () => {
  socket && socket.close()
  if (!socket) {
    console.log('建立websocket连接');
    socket = new WebSocket(wsUrl);
    socket.onopen = onopenWS;
    socket.onmessage = onmessageWS;
    socket.onerror = onerrorWS;
    socket.onclose = oncloseWS;
  } else {
    console.log('websocket已连接');
  }
}

export const initSocket = url => {
	isShutdown = false;
	wsUrl = url;
}

/**打开WS之后发送心跳 */
const onopenWS = () => {
  sendPing();
}

/**连接失败重连 */
const onerrorWS = () => {
  socket.close();
  clearInterval(setIntervalWesocketPush);
  console.log('连接失败重连中');
  if (socket.readyState !== 3) {
    socket = null;
    startSocket();
  }
}

/**WS数据接收统一处理 */
const onmessageWS = e => {
	var messageEvent = JSON.parse(e.data)["event"];
	//htmlBuildProgress,htmlBuildProgressInProductSeries,chessDemandDealProgress,
	//chessQzoneChangeNotify,todoNotify,checkNotify,unCheckNotify,amountChangeNotify
	console.log("收到" + messageEvent + "消息");
	if (eventList.includes(messageEvent)) {
		window.dispatchEvent(new CustomEvent(messageEvent, {
			detail: e.data
		}))
	} else {
		console.log("不支持的消息");
	}
}

/**
 * 发送数据但连接未建立时进行处理等待重发
 * @param {any} message 需要发送的数据
 */
const connecting = message => {
  setTimeout(() => {
    if (socket.readyState === 0) {
      connecting(message);
    } else {
      socket.send(JSON.stringify(message));
    }
  }, 1000)
}

/**
 * 发送数据
 * @param {any} message 需要发送的数据
 */
export const sendWSPush = message => {
  if (socket !== null && socket.readyState === 3) {
    socket.close();
    startSocket();
  } else if (socket.readyState === 1) {
    socket.send(JSON.stringify(message));
  } else if (socket.readyState === 0) {
    connecting(message);
  }
}

/**断开重连 */
const oncloseWS = () => {
  clearInterval(setIntervalWesocketPush);
  console.log('websocket已断开');
  if (socket.readyState !== 2) {
    socket = null;
	if (!isShutdown) {
	  console.log('websocket正在尝试重连');
      startSocket();
	}
  }
}
/**发送心跳
 * @param {number} time 心跳间隔毫秒 默认5000
 * @param {string} ping 心跳名称 默认字符串ping
 */
export const sendPing = (time = 30000, ping = 'ping') => {
  clearInterval(setIntervalWesocketPush)
  socket.send(ping)
  setIntervalWesocketPush = setInterval(() => {
    socket.send(ping)
  }, time)
}

/**发送心跳
 * @param {number} time 心跳间隔毫秒 默认5000
 * @param {string} ping 心跳名称 默认字符串ping
 */
export const closeSocket = () => {
  isShutdown = true;
  if (socket != null) {
	socket.close();
  }
}